var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "liff-reservation-form"
  }, [_c('DynamicForm', {
    ref: "dynamicForm",
    attrs: {
      "input-subjects": _vm.fields,
      "phone-verification-config": _vm.phoneVerificationConfig
    },
    on: {
      "file-uploading": _vm.updateFileUploading
    },
    model: {
      value: _vm.dynamicFormInput,
      callback: function callback($$v) {
        _vm.dynamicFormInput = $$v;
      },
      expression: "dynamicFormInput"
    }
  }), _c('div', {
    staticClass: "wizard-mode-layout__footer-navigation"
  }, [_c('div', {
    staticClass: "wizard-mode-layout__footer-button-wrapper"
  }, [_vm.hasPreviousStep() ? _c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.isFileUploading
    },
    on: {
      "click": _vm.handleNegativeButtonClicked
    }
  }, [_vm._v(" 上一步 ")]) : _vm._e(), _c('button', {
    staticClass: "s-btn s-liff-theme-btn s-btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.isFileUploading
    },
    on: {
      "click": _vm.handlePositiveButtonClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.textForProceedButton()) + " ")])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }